import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { TabPanel } from '../../helpers/TabPanel'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import inventoryPagesRoleManagement from '../../staticRoleManagement/inventoryRoleManagement'
import { ROLE } from '../../staticRoleManagement/types'
import { Inventory } from '../Inventory'
import InventoryAllocateAvailability from '../InventoryAllocateAvailability'
import InventoryAllocateHistory from '../InventoryAllocateHistory'
import InventoryBulkReset from '../InventoryBulkReset'
import InventoryBulkUpdate from '../InventoryBulkUpdate'
import useStyles from './styles/index.styles'

export default function InventoryTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const isRoleChannel =
    getRoleFromStorage() === ROLE.CHANNEL ||
    getRoleFromStorage() === ROLE.CHANNEL_ADMIN

  if (page === 'inventory') {
    return <Redirect to={`${pathname}/table`} />
  }

  const tabsList = [
    {
      disableRipple: true,
      value: 'table',
      className: classes.tab,
      label: getTranslate('Table'),
      link: '/inventory/table',
      component: LocalizedLink
    },
    {
      disableRipple: false,
      value: 'allocate-availability',
      className: classes.tab,
      label: getTranslate('Allocate Availability'),
      link: '/inventory/allocate-availability',
      component: LocalizedLink
    },
    {
      disableRipple: false,
      value: 'allocate-history',
      className: classes.tab,
      label: getTranslate('Allocate History'),
      link: '/inventory/allocate-history',
      component: LocalizedLink
    },
    {
      disableRipple: false,
      value: 'bulk-update',
      className: classes.tab,
      label: getTranslate('Bulk Update'),
      link: '/inventory/bulk-update',
      component: LocalizedLink
    },
    {
      disableRipple: false,
      value: 'bulk-reset',
      className: classes.tab,
      label: getTranslate('Bulk Reset'),
      link: '/inventory/bulk-reset',
      component: LocalizedLink
    }
  ]

  const validatedUsers = getRoleFromStorage() === ROLE.ADMIN

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = inventoryPagesRoleManagement.find(
    (item) => item.route === '/inventory/:page'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <PageHeader title={getTranslate('Table')} />
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {/* TODO:Allocate hardcode remove filter later */}
          {tabsList
            .filter((tabItem) => {
              // Hide "table" tab for CHANNEL and CHANNEL_ADMIN roles
              if (tabItem.value !== 'table' && isRoleChannel) {
                return false
              }

              // Check the access limitation for specific tabs
              const isRestrictedTab = [
                'allocate-availability',
                'allocate-history'
              ].includes(tabItem.value)

              if (isRestrictedTab) {
                return validatedUsers
              }

              // Apply existing role-based filtering logic
              return visibleTabs
            })
            .map((tabItem) => (
              <Tab
                key={tabItem.value}
                disableRipple={tabItem.disableRipple}
                value={tabItem.value}
                className={tabItem.className}
                label={tabItem.label}
                to={tabItem.link}
                component={tabItem.component}
              />
            ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="table"
        dir={theme.direction}
        className={classes.tabPanel}>
        <Inventory />
      </TabPanel>
      {validatedUsers && (
        <>
          <TabPanel
            value={page}
            index="allocate-availability"
            dir={theme.direction}
            className={classes.tabPanel}>
            <InventoryAllocateAvailability />
          </TabPanel>
          <TabPanel
            value={page}
            index="allocate-history"
            dir={theme.direction}
            className={classes.tabPanel}>
            <InventoryAllocateHistory />
          </TabPanel>
        </>
      )}
      {!isRoleChannel && (
        <>
          <TabPanel
            value={page}
            index="bulk-update"
            dir={theme.direction}
            className={classes.tabPanel}>
            <InventoryBulkUpdate />
          </TabPanel>
          <TabPanel
            value={page}
            index="bulk-reset"
            dir={theme.direction}
            className={classes.tabPanel}>
            <InventoryBulkReset />
          </TabPanel>
        </>
      )}
    </div>
  )
}
